/**
 * Клиентская ошибка валидации данных для запроса позиции услуги
 */
export enum EBetPositionClientError {
  /** услуги размещения отсутствуют **/
  servicesEmpty = 'servicesEmpty',
  /** адрес объявления не указан **/
  geoEmpty = 'geoEmpty',
  /** цена объявления не указана **/
  priceEmpty = 'priceEmpty',
  /** адрес и цена объявления не указаны **/
  priceAndGeoEmpty = 'priceAndGeoEmpty',
}
